module.exports = __webpack_public_path__ + "img/checkin-waiting.ffd88015.svg";